import React from 'react';

import Admin from '../components/Admin';

const AdminPage: React.FC = () => (
    <Admin />
);

export default AdminPage;
